import { HIDDEN_CLASS } from 'views/assets/scripts/consts'
import { BREAKPOINT_MEDIUM } from 'views/consts'

import {
  GALLERY_MAJOR_SELECTOR,
  GALLERY_SELECTOR,
  VIDEO_SLIDE_DATA_SELECTOR,
} from './consts'
import Modal from './Modal'
import Slider from './Slider'
import Video from './Video'

const showRedPoint = overlay => {
  if (overlay?.classList.contains(HIDDEN_CLASS)) {
    overlay.classList.remove(HIDDEN_CLASS)
  }
}

const hideRedPoint = overlay => {
  if (overlay && !overlay.classList.contains(HIDDEN_CLASS)) {
    overlay.classList.add(HIDDEN_CLASS)
  }
}

// TODO: move this fn out of this module
// to where it's used or to helpers.js
export const handleRedPointDisplay = (slider, overlay) => {
  if (slider?.getInfo) {
    const info = slider.getInfo()
    const item = info.slideItems[info.index]
    if (
      item.dataset.clientsideHook &&
      item.dataset.clientsideHook.indexOf(VIDEO_SLIDE_DATA_SELECTOR) !== -1
    ) {
      hideRedPoint(overlay)
    } else {
      showRedPoint(overlay)
    }
  }
}

export const initGallery = gallery => {
  const ctx = {
    modalSlider: null,
    majorSlider: null,
    thumbnailSlider: null,
    galleryElement: document.querySelector(GALLERY_SELECTOR),
    isLargeViewport: window.matchMedia(BREAKPOINT_MEDIUM).matches,
    handleRedPointDisplay,
  }

  const shouldInit =
    gallery && Boolean(gallery.querySelector(GALLERY_MAJOR_SELECTOR))

  if (shouldInit) {
    ctx.video = new Video(ctx)
    ctx.modal = new Modal(ctx)
    ctx.slider = new Slider(ctx)
  }

  return { ctx, shouldInit }
}

export const initMediaGalleries = () => {
  const galleries = document.querySelectorAll(GALLERY_SELECTOR)

  if (galleries.length) {
    Array.prototype.forEach.call(galleries, gallery => initGallery(gallery))
    return galleries
  }

  return null
}
